module.exports = __webpack_public_path__ + "img/trulySettle.c006ff41.png";